import { BuyStep2Page } from './../buy-step2/buy-step2';
import { AlbumService } from './../../service/album.service';
import { MediaService } from './../../service/media.service';
import { album } from './../../models/album.model';
import { media } from './../../models/media.model';
import { Component, OnInit } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BuyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-buy',
  templateUrl: 'buy.html',
})
export class BuyPage implements OnInit {

  public media: media;
  public album: album;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public mService: MediaService,
    public aService: AlbumService
    ) {
  }

  ngOnInit(){
    let media_id = this.navParams.get("media_id");

    if (media_id)
    {

      this.media = this.mService.medias[media_id];
      this.album = this.aService.getAlbum(this.media.album.id);

    }
    else
    {
      let album_id = this.navParams.get("album_id");
      this.album = this.aService.getAlbum(album_id);
    }
  }

  BuyMedia()
  {
    this.navCtrl.push(BuyStep2Page, { "media" : this.media });
  }
  BuyAlbum()
  {
    this.navCtrl.push(BuyStep2Page, { "album" : this.album });
  }



}



// WEBPACK FOOTER //
// ./src/pages/buy/buy.ts